import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCognito } from '../hooks/useCognito';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const { loading, isAuthenticated, error } = useCognito();
  const [processingTime, setProcessingTime] = useState(0);

  useEffect(() => {
    const startTime = Date.now();
    const timer = setInterval(() => {
      setProcessingTime(Math.floor((Date.now() - startTime) / 1000));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // 認証処理が完了したらメインページにリダイレクト
    if (!loading && isAuthenticated) {
      console.log('[DEBUG] Authentication successful, redirecting to main page');
      setTimeout(() => {
        navigate('/', { replace: true });
      }, 1000);
    }
  }, [loading, isAuthenticated, navigate]);

  if (loading) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-content">
          <div className="loading-spinner">🔄</div>
          <h2>認証処理中...</h2>
          <p>ログイン処理を行っています。しばらくお待ちください。</p>
          <div className="processing-info">
            <p>処理時間: {processingTime}秒</p>
            <div className="progress-steps">
              <div className="step completed">✓ 認証コード受信</div>
              <div className="step processing">⏳ トークン処理中</div>
              <div className="step pending">⏸ セッション確認</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-content error">
          <div className="error-icon">⚠️</div>
          <h2>認証エラー</h2>
          <p>認証処理中にエラーが発生しました。</p>
          <p className="error-message">{error}</p>
          <button 
            onClick={() => navigate('/', { replace: true })}
            className="back-button"
          >
            ホームに戻る
          </button>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="auth-callback-container">
        <div className="auth-callback-content success">
          <div className="success-icon">✅</div>
          <h2>認証完了</h2>
          <p>認証が正常に完了しました。メインページにリダイレクトします...</p>
          <div className="progress-steps">
            <div className="step completed">✓ 認証コード受信</div>
            <div className="step completed">✓ トークン処理完了</div>
            <div className="step completed">✓ セッション確認完了</div>
          </div>
        </div>
      </div>
    );
  }

  // 認証が完了していない場合
  return (
    <div className="auth-callback-container">
      <div className="auth-callback-content">
        <div className="warning-icon">⚠️</div>
        <h2>認証が完了しませんでした</h2>
        <p>認証処理が正常に完了しませんでした。再度お試しください。</p>
        <div className="debug-info">
          <p>処理時間: {processingTime}秒</p>
          <p>ローディング状態: {loading ? 'true' : 'false'}</p>
          <p>認証状態: {isAuthenticated ? 'true' : 'false'}</p>
        </div>
        <button 
          onClick={() => navigate('/', { replace: true })}
          className="back-button"
        >
          ホームに戻る
        </button>
      </div>
    </div>
  );
};

export default AuthCallback;
